import { render, staticRenderFns } from "./DeptSummary.vue?vue&type=template&id=d39ac788"
import script from "./DeptSummary.vue?vue&type=script&lang=js"
export * from "./DeptSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports